import React from "react";
import { Container } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import "./AgriStackComponent.css";
import "react-awesome-slider/dist/styles.css";
import AgriTechStack from "../../images/agriculture.png";
import { NavLink } from "react-router-dom";
import { Typography } from "@material-ui/core";

// Stack data containing information about different technology stacks
const stackData = [
  {
    title: "Cloud Gateway Stack", 
    image: AgriTechStack, 
    path: "/cloud-gateway-stack",
  },
  {
    title: "OTA Device Stack", 
    image: AgriTechStack, 
    path: "/ota-device-stack",
  },
];

// Main component rendering the Multi Cloud Stack 
const CloudStack = () => {
  return (
    <div
      maxwidth={12} // Defines the maximum width of the container
      className="businessPartnerContainer explore-app-background"
    >
      {/* Container for grid layout */}
      <Container maxWidth="sm" className="gridSection gridSection--mod">
        {/* Grid layout to display stack data */}
        <Grid
          container={true} 
          alignItems="center" 
          spacing={1} 
          direction="row" 
          justifyContent="center" 
        >
          {/* Mapping through stackData to render each stack */}
          {stackData.map(({ title, image, path }, index) => {
            return (
              <Grid
                item 
                md={3}
                sm={4} 
                xs={6} 
                key={index} 
                className="stack-data-container"
              >
                {/* Navigation link to stack details */}
                <NavLink to={path}>
                  <img src={image} alt={title} /> 
                  <Typography variant="h4" align="center">
                    {title}
                  </Typography>
                </NavLink>
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </div>
  );
};

export default CloudStack; // Exporting the component for use

